// Админка: ADMIN и MANAGER. Что именно доступно менеджеру — решают его права
export default defineNuxtRouteMiddleware(async () => {
    const isStaff = useStaff();

    if (!isStaff.value) return navigateTo({ name: "login" });
})
